import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { getByType } from "@/utils/content";

export default function CharacterRelations({ current }: { current: ContentItem }) {
  const others = getByType("character").filter((c) => c.id !== current.id);
  if (others.length === 0) return null;

  return (
    <section className="mt-10 pt-8 border-t border-background-200">
      <h2 className="font-heading font-bold text-xl text-foreground-950 mb-2">剧中人物介绍</h2>
      <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
        除 {current.subtitle || current.title} 之外，本剧还有这些重要角色，他们共同构成了《年轻的母亲3》的人物关系网。
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {others.map((char) => (
          <Link
            key={char.id}
            to={`/detail/${char.id}`}
            className="group flex items-center gap-3 p-3 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="w-14 h-14 rounded-full overflow-hidden bg-background-200 shrink-0">
              <img
                src={char.cover}
                alt={char.title}
                title={`${char.title} - 年轻的母亲3`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0">
              <p className="font-heading font-bold text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
                {char.subtitle || char.title}
              </p>
              <p className="mt-0.5 text-xs text-accent-700">{char.role}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}